import React from 'react';
import cx from './cx';

function Card({ children, className, hoverable = false, ...props }) {
  return (
    <section className={cx('rg-card', hoverable && 'rg-card--hoverable', className)} {...props}>
      {children}
    </section>
  );
}

export function CardHeader({ children, className, ...props }) {
  return (
    <header className={cx('rg-card__header', className)} {...props}>
      {children}
    </header>
  );
}

export function CardBody({ children, className, ...props }) {
  return (
    <div className={cx('rg-card__body', className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className, ...props }) {
  return (
    <footer className={cx('rg-card__footer', className)} {...props}>
      {children}
    </footer>
  );
}

export default Card;
